import { Link, useLocation } from "react-router-dom";
import { LogOut, Users, UserCog, LayoutDashboard } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

const LOGO_URL = "/agha_logo_sm.png";

export default function AppShell({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const isAdmin = user?.role === "admin";

  const navItem = (to, label, icon, testid) => {
    const active = loc.pathname === to || (to === "/" && loc.pathname.startsWith("/customer"));
    return (
      <Link
        to={to}
        data-testid={testid}
        className={`flex items-center gap-2 px-2.5 sm:px-4 py-2 rounded-lg text-sm transition-all ${
          active
            ? "bg-teal-700 text-white font-semibold shadow-sm shadow-teal-700/25"
            : "text-zinc-600 hover:bg-zinc-100 hover:text-zinc-900"
        }`}
      >
        {icon}
        <span className="hidden sm:inline">{label}</span>
      </Link>
    );
  };

  return (
    <div className="min-h-screen bg-[#F4F1EA] flex flex-col">
      <header className="bg-white/80 backdrop-blur-md border-b border-zinc-200 sticky top-0 z-40 no-print">
        <div className="max-w-[1400px] mx-auto px-3 sm:px-6 py-3 flex items-center justify-between gap-2 sm:gap-6">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="h-11 w-11 sm:h-14 sm:w-14 flex items-center justify-center group-hover:scale-105 transition-transform">
              <img
                src={LOGO_URL}
                alt="Agha Phone"
                className="h-full w-full object-contain drop-shadow-md"
              />
            </div>
            <div className="hidden sm:block">
              <div className="text-lg font-display font-bold text-teal-800 leading-tight font-latin">Agha Phone</div>
            </div>
          </Link>

          <nav className="flex items-center gap-1">
            {navItem("/", "الزبائن", <LayoutDashboard className="h-4 w-4" />, "nav-dashboard")}
            {isAdmin && navItem("/admin", "إدارة الموظفين", <Users className="h-4 w-4" />, "nav-admin")}
            {navItem("/profile", "حسابي", <UserCog className="h-4 w-4" />, "nav-profile")}
          </nav>

          <div className="flex items-center gap-1 sm:gap-3">
            <div className="text-left hidden sm:block">
              <div className="text-sm font-bold text-zinc-900" data-testid="current-user-username">{user?.username}</div>
              <div className="text-[11px] text-amber-700 font-semibold">{user?.role === "admin" ? "أدمن" : "موظف"}</div>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={logout}
              data-testid="logout-btn"
              className="text-zinc-600 hover:text-red-600 hover:bg-red-50"
            >
              <LogOut className="h-4 w-4 ms-1" />
              <span className="hidden sm:inline">خروج</span>
            </Button>
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
    </div>
  );
}
